<p class="text-[14px] sm:text-[16px] leading-loose font-normal">
    Welcome to the contributions website for
    <b>
        <a class="text-green-600" target="_blank"
            href="https://lge-ku.com/">LG&E and KU Energy
            LLC.</a>
    </b>
    <br> <br>
    LG&E and KU have a long standing commitment within the
    communities
    we serve of being a good corporate citizen. Over the years,
    corporate citizenship and community involvement have played
    an
    integral role in the company's tradition and culture.

    <br> <br>
    Through our <b>Community Grants</b>, <b>Plant for the Planet</b> matching
    grant program, and <b>Event Sponsorship</b>, LG&E and KU foundation support
    non-profit
    programs and activities focusing on education, environment,
    economic
    development, health and human services, and diversity. We
    invite
    organizations whose work aligns with these
    areas to explore the grant that best matches their efforts
    and
    submit an online application for consideration.
    <br> <br>
    Please read <a class="text-green-600 font-bold"
        href="https://lge-ku.com/sites/default/files/CharitableContributionsExternalUser.pdf">General
        Instructions</a> before applying.
    <br> <br>
    Contact <a class="text-green-600 font-bold"
        href="mailto:contributions@lge-ku.com">contributions@lge-ku.com</a>
    for questions.
    <br> <br>
    <b class="bg-yellow-300/75">This site is best
        viewed
        with the latest version of Google
        Chrome, Firefox, and Safari.</b>
</p>